import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSluisHor4Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sluis-hor-4";
		this.icon = svg_sluis_hor_4;
	}
}

window.customElements.define("inspx-draw-sluis-hor-4-module", DrawSluisHor4Module);

const svg_sluis_hor_4 = html`
<svg width="90" height="45" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect stroke="#444444" id="svg_2" height="44.7166" width="90"  fill="#ffffff"/>
 <rect stroke="#444444" fill="#aaa7a7" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="0.42791" y="0.43774" width="44.41677" height="43.74934" id="svg_5"/>
 <line stroke="#444444" id="svg_3" y2="0.50056" x2="45.2834" y1="45.11705" x1="45.2834" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
 <text stroke="#444444" transform="matrix(0.7865640806243794,0,0,0.8817506323334106,-25.8787736418564,-18.065804772613273) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="53.76739" x="91.05168" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">sluis</text>
</g>
</svg>
`;
